export class ItemParametersLengthValues {
    defaultLengths?: LengthDetails[];
}

export class LengthDetails {
    plantsId?: number[];
    smsId?: number[];
    rawMaterialGradesId?: number[];
    lengthType?: string;

    odMinMetric?: number;
    odMaxMetric?: number;
    idMinMetric?: number;
    idMaxMetric?: number;
    wtMinMetric?: number;
    wtMaxMetric?: number;

    odMinImperial?: number;
    odMaxImperial?: number;
    idMinImperial?: number;
    idMaxImperial?: number;
    wtMinImperial?: number;
    wtMaxImperial?: number;

    minLengthMetric?: number;
    maxLengthMetric?: number;
    minLengthImperial?: number;
    maxLengthImperial?: number;
}